declare global {
	interface Window {
		__ENV__?: Record<string, string>
	}
}

export function getRuntimeEnv(key: string): string {
	const windowVal =
		typeof window !== "undefined" && window.__ENV__
			? window.__ENV__[key]
			: undefined
	return windowVal ?? (import.meta.env as Record<string, string>)[key] ?? ""
}
